module.exports = "/images/gifting-banner.png";